// Built @Wed, 27 Dec 2023 03:56:16 GMT
import { createClass as _createClass, classCallCheck as _classCallCheck } from "../_virtual/_rollupPluginBabelHelpers.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.keys.js";
import { transformHeader, log, getXhr } from "./util.js";
var defaultConfig = {
  range: "0-1048576",
  timer: 60 * 1e3,
  timeout: 15e3
};
var SpeedCheckTask = /* @__PURE__ */ function() {
  function SpeedCheckTask2() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    _classCallCheck(this, SpeedCheckTask2);
    Object.keys(defaultConfig).map(function(key) {
      if (options[key] === void 0 || options[key] === null) {
        options[key] = defaultConfig[key];
      }
    });
    this.options = options;
    this._headers = {};
    this.intervalId = null;
    this.ishangUp = false;
    this._data = {
      contentLength: 0,
      statusText: "",
      status: -1,
      speed: 0,
      costTime: 0,
      connectTime: 0,
      contentType: ""
    };
    this.url = [];
  }
  _createClass(SpeedCheckTask2, [{
    key: "setData",
    value: function setData(data) {
      var _this = this;
      Object.keys(data).map(function(key) {
        if (key !== "headers") {
          _this._data[key] = data[key];
        }
      });
      if (data.headers && Object.keys(data.headers).length > 0) {
        this._headers = transformHeader(data.headers);
        data.headers["content-type"] && (this._data.contentType = data.headers["content-type"]);
        var resrange = data.headers["content-range"] || "";
        var arr = resrange.split("/");
        if (arr && arr.length > 1) {
          this._data.contentLength = parseInt(arr[1]);
        }
      }
    }
  }, {
    key: "contentLength",
    get: function get() {
      return this._data.length || 0;
    }
  }, {
    key: "trigger",
    value: function trigger(url) {
      var _this2 = this;
      var type = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "start";
      var options = this.options;
      this.url = url;
      if (this.url && (type === "start" || !this.ishangUp && !this.intervalId)) {
        log("task>>trigger url ", url);
        this.ishangUp = true;
        this.intervalId && this.clear();
        this.intervalId = setTimeout(function() {
          _this2.clear();
        }, type === "start" ? 500 : options.timer);
        getXhr(this.url, {
          range: type === "start" ? "0-1024" : options.range,
          timeout: options.timeout
        }).then(function(data) {
          log("getXhr>>check result ", data);
          _this2.setData(data || {});
          _this2.ishangUp = false;
        }).catch(function(e) {
          log("getXhr>>error ", e);
          _this2.ishangUp = false;
          _this2._data.status = -1;
        });
      } else {
        log("task>>cant`t trigger url", this.ishangUp, this.intervalId);
      }
    }
  }, {
    key: "url",
    get: function get() {
      return this.options.url;
    },
    set: function set(value) {
      value && (this.options.url = value);
    }
  }, {
    key: "serverIp",
    get: function get() {
      return this._headers.x_response_sinfo || "";
    }
  }, {
    key: "headers",
    get: function get() {
      return this._headers || {};
    }
  }, {
    key: "status",
    get: function get() {
      return this._data.status || -1;
    }
  }, {
    key: "speed",
    get: function get() {
      return this._data.speed;
    }
  }, {
    key: "clear",
    value: function clear() {
      clearTimeout(this.intervalId);
      this.intervalId = null;
    }
  }]);
  return SpeedCheckTask2;
}();
export {
  SpeedCheckTask as default
};
